module.exports = __webpack_public_path__ + "static/img/1_0035.87df4a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0035.jpg
// module id = 4/CM
// module chunks = 0